var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-item"},[_c('AntCard',{attrs:{"title":_vm.title}},[_vm._t("default"),_c('template',{staticClass:"ant-card-actions",slot:"actions"},[_c('div',{staticClass:"map-link",on:{"click":function($event){return _vm.$emit('mapClicked')}}},[_c('MapIcon',{attrs:{"type":"map"}}),_c('span',[_vm._v("zur Kartenansicht")])],1)])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }